import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useGetBlogPostBySlugQuery } from '@/api/client';
import Header from '@feature/app-download/components/Header';
import MobileMenu from '@feature/app-download/components/MobileMenu';
import { useResponsive } from '@feature/app-download/hooks/useResponsive';
import RichTextContent from './components/RichTextContent';
import './Blog.css';

function BlogDetailPage() {
  const isMobile = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);
  const { slug } = useParams<{ slug: string }>();
  const { data: post, isLoading, isError } = useGetBlogPostBySlugQuery(slug!, { skip: !slug });

  useEffect(() => {
    if (post) {
      document.title = `${post.title} | Hereabout Blog`;
    }
    return () => {
      document.title = 'Hereabout';
    };
  }, [post]);

  if (isLoading) {
    return (
      <div className="blog-page">
        <Header isMobile={isMobile} onMenuToggle={() => setMenuOpen(!menuOpen)} />
        <MobileMenu menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        <div className="blog-page-loading">Loading...</div>
      </div>
    );
  }

  if (isError || !post) {
    return (
      <div className="blog-page">
        <Header isMobile={isMobile} onMenuToggle={() => setMenuOpen(!menuOpen)} />
        <MobileMenu menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        <div className="blog-page-empty">
          <p>Post not found.</p>
          <Link to="/blog" className="blog-back-link">Back to blog</Link>
        </div>
      </div>
    );
  }

  const date = post.published_at
    ? new Date(post.published_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : new Date(post.created_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

  return (
    <div className="blog-page">
      <Header isMobile={isMobile} onMenuToggle={() => setMenuOpen(!menuOpen)} />
      <MobileMenu menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <main className="blog-page-content">
        <Link to="/blog" className="blog-back-link">&larr; All posts</Link>
        <article className="blog-article">
          <header className="blog-article-header">
            <h1 className="blog-article-title">{post.title}</h1>
            <div className="blog-article-meta">
              <time>{date}</time>
            </div>
          </header>
          <RichTextContent html={post.content} />
        </article>
      </main>
    </div>
  );
}

export default BlogDetailPage;
